import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { centerOfWeight2, centroid as _centroid, } from "@thi.ng/geom-poly-utils";
import { add, divN, maddN, mixN, mulN, set } from "@thi.ng/vectors";
import { dispatch } from "../internal/dispatch";
import { bounds } from "./bounds";
export const centroid = defmulti(dispatch);
centroid.addAll({
    [Type.CIRCLE]: ($, out) => set(out || [], $.pos),
    [Type.GROUP]: ($) => {
        const b = bounds($);
        return b ? centroid(b) : undefined;
    },
    [Type.LINE]: ({ points }, out) => mixN(out || [], points[0], points[1], 0.5),
    [Type.POINTS]: ($, out) => _centroid($.points, out),
    [Type.PLANE]: ($, out) => mulN(out || [], $.normal, $.w),
    [Type.POLYGON]: ($, out) => centerOfWeight2($.points, out),
    [Type.RECT]: ($, out) => maddN(out || [], $.size, 0.5, $.pos),
    [Type.TRIANGLE]: ({ points }, out) => divN(null, add(null, add(out || [], points[0], points[1]), points[2]), 3),
});
centroid.isa(Type.ARC, Type.CIRCLE);
centroid.isa(Type.AABB, Type.RECT);
centroid.isa(Type.ELLIPSE, Type.CIRCLE);
centroid.isa(Type.LINE3, Type.LINE);
centroid.isa(Type.POINTS3, Type.POINTS);
centroid.isa(Type.POLYLINE, Type.POINTS);
centroid.isa(Type.QUAD, Type.POLYGON);
centroid.isa(Type.SPHERE, Type.CIRCLE);
centroid.isa(Type.TEXT, Type.CIRCLE);
centroid.isa(Type.TRIANGLE3, Type.TRIANGLE);
